import * as React from "react";
import { StyledSuccessScreen } from "./styles";
import { SuccessScreenTypeProps } from "./types";

export const SuccessScreen = ({
  imageSrc,
  content,
  title,
  style,
  buttonElement,
}: SuccessScreenTypeProps) => {
  return (
    <StyledSuccessScreen style={style}>
      {imageSrc && <img height="280px" src={imageSrc} alt="Success" />}
      {title && <h4>{title}</h4>}
      {content && <p>{content}</p>}
      {buttonElement && buttonElement}
    </StyledSuccessScreen>
  );
};
